import {
  HStack,
  IconButton,
  IconButtonProps,
  StackProps,
} from "@chakra-ui/react";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaRedditAlien,
  FaTwitter,
} from "react-icons/fa";
import {
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
} from "react-share";
import { SocialMediaLinks } from "../footer/social-media-links";

export interface ShareSocialMediaButtonsProps extends StackProps {
  shareUrl: string;
  shareTitle?: string;
  shareHashtag: string;
  twitterAccounts?: string[];
  hashtags?: string[];
  summary?: string;
  iconSx?: Omit<IconButtonProps, "aria-label">;
}

export function ShareSocialMediaButtons({
  shareUrl = "https://areahub.com",
  shareHashtag = "AreaHub",
  shareTitle = "AreaHub – Reveal Your World",
  twitterAccounts = ["MyAreaHub"],
  hashtags = [],
  summary,
  iconSx,
  ...props
}: ShareSocialMediaButtonsProps) {
  return (
    <HStack
      w="full"
      alignItems="center"
      justifyContent={{
        base: "center",
        lg: "flex-end",
      }}
      {...props}
    >
      <FacebookShareButton
        url={shareUrl}
        quote={shareTitle}
        hashtag={shareHashtag}
        resetButtonStyle
      >
        <IconButton
          as="div"
          aria-label="Share on Facebook"
          isRound
          icon={<FaFacebookF />}
          color="white"
          bg="facebook"
          {...iconSx}
        />
      </FacebookShareButton>
      <TwitterShareButton
        url={shareUrl}
        title={shareTitle}
        hashtags={[shareHashtag, ...hashtags]}
        related={twitterAccounts}
        resetButtonStyle
        via={twitterAccounts[0]}
      >
        <IconButton
          as="div"
          aria-label="Share on Twitter"
          isRound
          icon={<FaTwitter />}
          bg="twitter"
          color="white"
          {...iconSx}
        />
      </TwitterShareButton>
      <LinkedinShareButton
        url={shareUrl}
        title={shareTitle}
        summary={summary}
        source="AreaHub"
        resetButtonStyle
      >
        <IconButton
          as="div"
          aria-label="Share on LinkedIn"
          isRound
          icon={<FaLinkedinIn />}
          bg="linkedin"
          color="white"
          {...iconSx}
        />
      </LinkedinShareButton>
      <RedditShareButton title={shareTitle} url={shareUrl} resetButtonStyle>
        <IconButton
          as="div"
          aria-label="Share on Reddit"
          isRound
          icon={<FaRedditAlien />}
          bg="red"
          color="white"
          {...iconSx}
        />
      </RedditShareButton>
    </HStack>
  );
}

export default SocialMediaLinks;
